import _regeneratorRuntime from "/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { gapi, gapiComplete } from './gapiScript';

var loadAuth2 =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(clientId, scopes) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              gapi.load('auth2', function () {
                resolve(gapi.auth2.init({
                  client_id: clientId,
                  scope: scopes
                }));
              });
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loadAuth2(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export { gapi, gapiComplete, loadAuth2 };